import { Text, textVariants, vars } from '@etg/wings';
import { date, string } from '@eti/utils';
import { useDateFormat } from '@eti/providers';
import { css } from '@eti/styles';
import { screenReaderOnly } from '../../common/utils/styles';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
const DOT_SIZE = 8;
const routeList = css`
  border-top: 1px solid ${vars.colors.divider};
  list-style: none;
  margin: 0;
  padding: 16px 8px;
`;
const routeListItem = css`
  & + & {
    margin-top: 16px;
  }
`;
const routeGrid = css`
  display: grid;
  gap: 0 8px;
  grid-template-columns: ${DOT_SIZE}px 1fr;
`;
const stopText = css`
  padding-block: 10px;
`;
const railEnd = css`
  align-items: center;
  display: flex;
  flex-direction: column;
`;
const railSpacer = css`
  flex: 1;
`;
const railLine = css`
  background: ${vars.colors.text.secondary};
  flex: 1;
  width: 1px;
`;
const middleLine = css`
  background: ${vars.colors.text.secondary};
  place-self: stretch center;
  width: 1px;
`;
const circleBase = css`
  border-radius: 50%;
  flex-shrink: 0;
  height: ${DOT_SIZE}px;
  width: ${DOT_SIZE}px;
`;
const emptyCircle = css`
  ${circleBase};
  border: 1px solid ${vars.colors.text.secondary};
  box-sizing: border-box;
`;
const filledCircle = css`
  ${circleBase};
  background: ${vars.colors.text.secondary};
`;
const RouteStops = ({
  bounds,
  departsText,
  fromText,
  showDepartureTime,
  toText
}) => {
  const {
    shortWeekdayYear,
    time,
    weekdayYear
  } = useDateFormat();
  const formatDeparts = (dateTime, weekdayFormat) => `${departsText} ${date.format(dateTime, time)}, ${string.firstToUpperCase(date.format(dateTime, weekdayFormat))}`;
  return /*#__PURE__*/_jsx("ul", {
    className: routeList,
    children: bounds.map((bound, index) => {
      const departs = showDepartureTime && bound.departureDateTime ? {
        announced: formatDeparts(bound.departureDateTime, weekdayYear),
        visible: formatDeparts(bound.departureDateTime, shortWeekdayYear)
      } : null;
      const screenReaderLabel = departs ? `${fromText} ${bound.departureStation}, ${departs.announced}, ${toText} ${bound.arrivalStation}` : `${fromText} ${bound.departureStation}, ${toText} ${bound.arrivalStation}`;
      return /*#__PURE__*/_jsxs("li", {
        className: routeListItem,
        "data-testid": "route-stops",
        children: [/*#__PURE__*/_jsx(Text, {
          as: "span",
          className: screenReaderOnly,
          children: screenReaderLabel
        }), /*#__PURE__*/_jsxs("div", {
          "aria-hidden": "true",
          className: routeGrid,
          children: [/*#__PURE__*/_jsxs("div", {
            className: railEnd,
            children: [/*#__PURE__*/_jsx("span", {
              className: railSpacer
            }), /*#__PURE__*/_jsx("span", {
              className: emptyCircle
            }), /*#__PURE__*/_jsx("span", {
              className: railLine
            })]
          }), /*#__PURE__*/_jsx(Text, {
            className: departs ? undefined : stopText,
            children: bound.departureStation
          }), departs ? /*#__PURE__*/_jsxs(_Fragment, {
            children: [/*#__PURE__*/_jsx("span", {
              className: middleLine
            }), /*#__PURE__*/_jsx(Text, {
              "data-testid": "route-stops-departs",
              variant: textVariants._12,
              children: departs.visible
            })]
          }) : null, /*#__PURE__*/_jsxs("div", {
            className: railEnd,
            children: [/*#__PURE__*/_jsx("span", {
              className: railLine
            }), /*#__PURE__*/_jsx("span", {
              className: filledCircle
            }), /*#__PURE__*/_jsx("span", {
              className: railSpacer
            })]
          }), /*#__PURE__*/_jsx(Text, {
            className: stopText,
            children: bound.arrivalStation
          })]
        })]
      }, `${bound.departureStation}-${bound.arrivalStation}-${index}`);
    })
  });
};
export default RouteStops;
//# sourceMappingURL=RouteStops.js.map